import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

/**
 * Collapsible dump of every column on the entity's DB record, so the detail
 * view always shows the complete field set (ACCOUNTS_TOOL_REQUIREMENTS.md
 * §3.0) even as the schema evolves — read-only by construction.
 */
const AllFieldsSection: React.FC<{ record: Record<string, unknown> }> = ({ record }) => {
  const [open, setOpen] = useState(false);
  const entries = Object.entries(record);

  const renderValue = (value: unknown): string => {
    if (value === null || value === undefined) return '—';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
  };

  return (
    <div className="border-t border-border-light pt-3 dark:border-border-dark">
      <button
        onClick={() => setOpen((current) => !current)}
        className="flex items-center gap-1 text-sm font-medium text-text-secondary hover:text-text-primary dark:text-text-dark-secondary dark:hover:text-text-dark-primary"
        aria-expanded={open}
      >
        {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        All database fields ({entries.length})
      </button>
      {open && (
        <div className="mt-2 overflow-x-auto">
          <table className="w-full text-xs">
            <tbody className="divide-y divide-border-light dark:divide-border-dark">
              {entries.map(([key, value]) => (
                <tr key={key}>
                  <td className="w-56 py-1 pr-4 align-top font-mono text-text-tertiary dark:text-text-dark-tertiary">
                    {key}
                  </td>
                  <td className="break-all py-1 font-mono text-text-secondary dark:text-text-dark-secondary">
                    {renderValue(value)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AllFieldsSection;
